import { RegisterComponent } from '../account/auth/register1/register.component';
import { TransportistaComponent } from './../pages/facturador/transportista/transportista.component';
import { PlanesComponent } from './planes/planes.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MaintenanceComponent } from './maintenance/maintenance.component';
import { Page404Component } from './page404/page404.component';
import { Page500Component } from './page500/page500.component';
import { Login1Component } from './login1/login1.component';
import { RecoverpasswordComponent } from './recoverpassword/recoverpassword.component';
import { LockscreenComponent } from './lockscreen/lockscreen.component';

const routes: Routes = [
    {
        path: 'maintenance',
        component: MaintenanceComponent
    },
    {
        path: '404',
        component: Page404Component
    },
    {
        path: '500',
        component: Page500Component
    },
    {
        path: 'login-1',
        component: Login1Component
    },

    {
        path: 'recoverpwd-1',
        component: RecoverpasswordComponent
    },
    {
        path: 'lock-screen-1',
        component: LockscreenComponent
    },
    {
        path: 'Planes',
        component: PlanesComponent
    }

];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ExtrapagesRoutingModule { }
